import 'jquery.marquee';

const $ = jQuery;

$(function () {
    // ----- running line -----
    const $line = $('.top-bar-text-line');

    $line.on('click', function(e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop:  $('#subscribe-form').offset().top
        }, 500);
        $('#subscribe-form #email-input').focus();
    });

    if ($line.length && typeof $line.marquee === 'function') {
        $line.marquee({
            duration: 15000,
            gap: 3,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true,
            duplicateCount: 6,
            pauseOnHover: false,
            startVisible: true
        });
    }

    // ----- burger / off-canvas toggle (still using MFP) -----
    $(document).on('click', '.nav-icon-toggle', function (e) {
        e.preventDefault();

        const $html       = $('html');
        const $hiddenBtn  = $('.nav-icon-hidden-trigger');

        // If off-canvas is already open – close it via MFP
        if ($html.hasClass('has-off-canvas')) {
            $('.mfp-bg').trigger('click');
            return;
        }

        // Otherwise open via hidden button with data-open
        if ($hiddenBtn.length) {
            $hiddenBtn.trigger('click');
        }
    });

    // Sync burger state with MFP popup
    $(document).on('mfpOpen', function () {
        if ($('#main-menu').length > 0 && $.magnificPopup.instance.currItem.src === '#main-menu') {
            $('.nav-icon-toggle')
                .attr('aria-expanded', 'true')
                .find('.animate-burger')
                .addClass('is-open');
        }
    });


    $(document).on('click', '.mobile-nav .header-cart-link, .cart-contents', function (e) {
        if ($('html').hasClass('has-off-canvas')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const cartUrl = $(this).attr('href');
            $.magnificPopup.close();
            setTimeout(function() {
                if (cartUrl && cartUrl !== '#') {
                    $('.header-cart-link').first().trigger('click');
                }
            }, 300);
        }
    });

    $(document).on('mfpClose', function () {
        $('html').removeClass('has-off-canvas overflow-hidden');
        $('.nav-icon-toggle')
            .attr('aria-expanded', 'false')
            .find('.animate-burger')
            .removeClass('is-open');
    });

    // ----- login popup (simple JS toggle) -----
    const $loginPopup = $('#login-form-popup');

    if ($loginPopup.length) {
        const OPEN_CLASS = 'login-popup-trigger-show';

        // Remove Magnific Popup hide class if present
        $loginPopup.removeClass('mfp-hide');

        function openLoginPopup() {
            // Open popup
            $loginPopup.addClass(OPEN_CLASS);
            $('html').addClass('overflow-hidden');
        }

        function closeLoginPopup() {
            // Close popup
            $loginPopup.removeClass(OPEN_CLASS);
            $('html').removeClass('overflow-hidden');
        }

        // Open on trigger click
        $(document).on('click', 'a.login-popup-trigger, .login-popup-trigger > a', function (e) {
            e.preventDefault();

            // Close all Magnific Popup instances if any are open
            if ($.magnificPopup && $.magnificPopup.instance && $.magnificPopup.instance.isOpen) {
                $.magnificPopup.close();
            }

            // Explicitly reset burger state (in case off-canvas was open)
            $('.nav-icon-toggle')
                .attr('aria-expanded', 'false')
                .find('.animate-burger')
                .removeClass('is-open');

            // Open our custom login popup
            openLoginPopup();
        });

        // Close on close icon(s)
        $(document).on('click', '#login-form-popup .mfp-close, #login-form-popup .login-popup-close, #login-form-popup .icon-close', function (e) {
            e.preventDefault();
            closeLoginPopup();
        });

        // Close on overlay click (click exactly on wrapper)
        $(document).on('click', '#login-form-popup', function (e) {
            if (e.target === this) {
                closeLoginPopup();
            }
        });

        // Close on ESC
        $(document).on('keyup', function (e) {
            if (e.key === 'Escape') {
                closeLoginPopup();
            }
        });
    }
});
